// extracted by mini-css-extract-plugin
export default {"policy-holders-list":"styles_policy-holders-list__1p27K","relative-scrollbar":"styles_relative-scrollbar__JFoUv"};